import { useState, useEffect, useRef, use } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
// import ChatSessionsList from './ChatSessionsList';
import ChatContent from './ChatContent';
import { usePostMessageToAssistant } from './assistantUtils';

interface ChatPopupProps {
  open: boolean;
  onClose: () => void;
}

export default function ChatPopup({ open, onClose }: ChatPopupProps) {
  const [input, setInput] = useState<string>('');
  const chatRef = useRef<HTMLDivElement>(null!);

  const { postMessage, isPosting, sessionId, messages, setMessages, isStreaming } =
    usePostMessageToAssistant();

  const handleSend = async () => {
    if (!input.trim()) return;

    // Add user message immediately
    const userMessage = { role: 'user' as const, content: input };
    setMessages((prev) => [...prev, userMessage]);

    const payload = {
      message: input,
      ...(sessionId && { id: sessionId.toString() }),
    };

    setInput('');
    postMessage(payload);
  };

  // scroll to bottom when messages change
  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTo({ top: chatRef.current.scrollHeight, behavior: 'smooth' });
    }
  }, [isPosting, messages]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        <Stack direction="row" spacing={2}>
          <AutoAwesomeIcon />
          <Typography variant="h6">Bento AI Assistant</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack direction="row" spacing={2} sx={{ height: '500px' }}>
          {/* <ChatSessionsList
            chatSessions={messagesContextsState}
            currentSessionId={sessionId}
            onSessionSelect={setSessionId}
            onCreateNewChat={createNewChat}
            onDeleteSession={deleteContext}
            isRunning={isPosting}
          /> */}
          <ChatContent
            chatRef={chatRef}
            chatHistory={messages}
            isLoading={isPosting}
            isStreaming={isStreaming}
            input={input}
            setInput={setInput}
            handleSend={handleSend}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
